<div class="viva-toggle-container" [class.same-size]="sameSizeClass" [class.invalid]="isInvalid" [class.disabled]="disabled">
  <div class="options-container" *ngIf="options">
    <div *ngFor="let option of options; let i = index" class="option" [class.first]="i === 0"
      [class.last]="i === options.length - 1" [ngClass]="getOptionClasses(option)" (click)="selectOption(option)"   [ngStyle]="getOptionStyles(option)">
      
      <img *ngIf="option.src  && (!option.imagePosition || option.imagePosition === 'start')" [src]="option.src"
        alt="{{ option.display }}" class="option-image">
      {{ option.display }}
      <img *ngIf="option.src  &&  option.imagePosition === 'end'" [src]="option.src" alt="{{ option.display }}"
        class="option-image">
    </div>
  </div>
</div>
